// @flow

/*
export const API: Object = {
  CreateUserRegistration: 'CreateUserRegistration',
  SendUserRegistrationSMSCode : 'SendUserRegistrationSMSCode',
  ValidateUserRegistrationSMSCode : 'ValidateUserRegistrationSMSCode'
}
*/

export const API: {
  CreateUserRegistration: string,
  SendUserRegistrationSMSCode: string,
  ValidateUserRegistrationSMSCode: string,
  UpdateUserRegistration: string,
  GetUserRegistration: string,
  GetUserDataFromFC: string,
  SuggestNickname: string,
  SendPseudoTmp: string,
  UploadUserRegistrationKYC: string,
  ScanUserRegistrationKYC: string,
  IsAvailableNickname: string,
  ScanCreditCard: string,
  StartDeposit: string,
  CheckDeposit: string,
  ListAvailableDepositMethods: string,
  ValidateUserRegistrationDomiciliationCode: string,
  // TODO : REPLACE BY REAL METHOD
  SendUserRegistrationValidationCode: string,
  ListInternationalCountryCallingCodes: string,
  SearchPlaces: string,
  SetSessionId: string,
  GetPlaceDetails: string,
  GetLanding: string,
  GetDataLayer: string,
} = {
  CreateUserRegistration: 'CreateUserRegistration',
  SendUserRegistrationSMSCode: 'SendUserRegistrationSMSCode',
  ValidateUserRegistrationSMSCode: 'ValidateUserRegistrationSMSCode',
  UpdateUserRegistration: 'UpdateUserRegistration',
  GetUserRegistration: 'GetUserRegistration',
  GetUserDataFromFC: 'GetUserDataFromFC',
  SuggestNickname: 'SuggestNickname',
  SendPseudoTmp: 'SendPseudoTmp',
  UploadUserRegistrationKYC: 'UploadUserRegistrationKYC',
  ScanUserRegistrationKYC: 'ScanUserRegistrationKYC',
  IsAvailableNickname: 'IsAvailableNickname',
  ScanCreditCard: 'ScanCreditCard',
  StartDeposit: 'StartDeposit',
  CheckDeposit: 'CheckDeposit',
  ListAvailableDepositMethods: 'ListAvailableDepositMethods',
  ValidateUserRegistrationDomiciliationCode: 'ValidateUserRegistrationDomiciliationCode',
  SendUserRegistrationValidationCode: 'SendUserRegistrationValidationCode',
  ListInternationalCountryCallingCodes: 'ListInternationalCountryCallingCodes',
  SearchPlaces: 'SearchPlaces',
  SetSessionId: 'SetSessionId',
  GetPlaceDetails: 'GetPlaceDetails',
  GetLanding: 'GetLanding',
  GetDataLayer: 'GetDataLayer',
};
